var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pointes-list"
  }, [_c('div', {
    staticClass: "records-list"
  }, _vm._l(_vm.items, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "record s-mb-3"
    }, [_c('div', [_c('div', {
      staticClass: "record__title"
    }, [_vm._v(_vm._s(item.name))]), _c('div', {
      staticClass: "record__desc"
    }, [_c('div', {
      staticClass: "record__date"
    }, [_vm._v("交易日期 " + _vm._s(item.date))]), item.end_date ? _c('div', {
      staticClass: "record__date mb-0"
    }, [_vm._v("到期日 " + _vm._s(item.end_date))]) : _vm._e()])]), _c('div', {
      staticClass: "s-text-primary record__point"
    }, [item.is_redeem ? _c('span', [_vm._v(" - ")]) : _vm._e(), _vm._v(" " + _vm._s(item.point) + " ")])]);
  }), 0), _vm.items.length > 0 ? _c('PointPagination', {
    attrs: {
      "totalPage": _vm.totalPage
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }